const HTML_PARSER = {
  NAME_BLOCKQUOTE: 'blockquote',
  NAME_BOLD: 'b',
  NAME_BR: 'br',
  NAME_DIV: 'div',
  NAME_EM: 'em',
  NAME_FIGCAPTION: 'figcaption',
  NAME_FIGURE: 'figure',
  NAME_H1: 'h1',
  NAME_H2: 'h2',
  NAME_H3: 'h3',
  NAME_H4: 'h4',
  NAME_HR: 'hr',
  NAME_HREF: 'a',
  NAME_IFRAME: 'iframe',
  NAME_IMAGE: 'img',
  NAME_ITALIC: 'i',
  NAME_LIST_ITEM: 'li',
  NAME_ORDERED_LIST: 'ol',
  NAME_PARAGRAPH: 'p',
  NAME_PRODUCT_RANKING_TABLE: 'ranking-table',
  NAME_SPAN: 'span',
  NAME_STRONG: 'strong',
  NAME_TABLE: 'table',
  NAME_TABLE_CELL: 'td',
  NAME_UNORDERED_LIST: 'ul',
  WISHLIST_KEYWORD_BLOCK_CLASS_ATTRIBUTE: 'blog__keyword-suggestion',
  WISHLIST_KEYWORD_CLASS_ATTRIBUTE: 'follow_keyword',
};

export default HTML_PARSER;
